import { SquareTwoStack } from "@medusajs/icons"
import { IconButton, Text } from "@medusajs/ui"
import { copyText } from "../lib/clipboard"
import { t, tk } from "../lib/i18n"
import type { BoxNowLines } from "../lib/medusa"

const ROWS: Array<{ key: keyof Omit<BoxNowLines, "complete">; label: string; copy: string; copied: string }> = [
  { key: "name", label: tk("Name"), copy: tk("Copy the name"), copied: tk("Name copied.") },
  { key: "email", label: tk("Email"), copy: tk("Copy the email"), copied: tk("Email copied.") },
  { key: "phone", label: tk("Phone"), copy: tk("Copy the phone"), copied: tk("Phone copied.") },
  { key: "address", label: tk("Address"), copy: tk("Copy the address"), copied: tk("Address copied.") },
]

/**
 * The four lines the BOX NOW partner portal asks for, each with its own copy button, in the owners'
 * format (phone as 10 digits; "Street & Number, City, Postcode"). For a custom order they are read
 * from the sheet's free-text box, so a line may be missing — the box itself is shown below them.
 */
export function BoxNowCopy({ lines, fromText }: { lines: BoxNowLines; fromText?: boolean }) {
  const all = ROWS.map((row) => lines[row.key]).filter(Boolean).join("\n")
  return (
    <div className="bg-ui-bg-subtle flex flex-col gap-y-1 rounded-lg p-3">
      <div className="flex items-center justify-between gap-x-2">
        <Text size="xsmall" weight="plus" className="text-ui-fg-subtle">{t("For the BOX NOW portal")}</Text>
        {all && (
          <button type="button" className="txt-compact-xsmall-plus text-ui-fg-interactive" onClick={() => void copyText(all, t("All four copied."))}>
            {t("Copy all")}
          </button>
        )}
      </div>
      {ROWS.map((row) => {
        const value = lines[row.key]
        return (
          <div key={row.key} className="flex min-h-9 items-center justify-between gap-x-2">
            <div className="min-w-0">
              <Text size="xsmall" className="text-ui-fg-muted">{t(row.label)}</Text>
              <Text size="small" className={value ? "break-words" : "text-ui-fg-muted italic"}>{value || t("not found")}</Text>
            </div>
            {value && (
              <IconButton size="small" variant="transparent" aria-label={t(row.copy)} onClick={() => void copyText(value, t(row.copied))}>
                <SquareTwoStack />
              </IconButton>
            )}
          </div>
        )
      })}
      {fromText && !lines.complete && (
        <Text size="xsmall" className="text-ui-fg-muted">{t("Read from the customer box in the sheet — what it does not say is left out. Check the box itself.")}</Text>
      )}
    </div>
  )
}
